<div class="reports-container">
	<div class="mb-3 mt-3">
		<div class="input-group">
			<div class="input-group-append">
				<button nbButton status="primary" (click)="previousMonth()">
					<nb-icon icon="arrow-ios-back-outline"></nb-icon>
				</button>
			</div>
			<div class="ml-1">
				<input
					nbInput
					[placeholder]="
						'INTEGRATIONS.UPWORK_PAGE.DATE_RANGE_PLACEHOLDER'
							| translate
					"
					[nbDatepicker]="rangePicker"
					[value]="displayDate"
				/>
				<nb-rangepicker
					#rangePicker
					[range]="defaultDateRange$ | async"
					[max]="today"
					(rangeChange)="handleRangeChange($event)"
				>
				</nb-rangepicker>
			</div>
			<div class="input-group-append ml-1">
				<button
					nbButton
					status="primary"
					(click)="nextMonth()"
					[disabled]="isNextButtonDisabled()"
				>
					<nb-icon icon="arrow-ios-forward-outline"></nb-icon>
				</button>
			</div>
		</div>
	</div>
	<ng2-smart-table
		class="contracts-table"
		[settings]="settingsSmartTable"
		[source]="reports$ | async"
		#contractsTable
	>
	</ng2-smart-table>
</div>
